import { SelectMenuProps } from '../../../components/UI/SelectMenu';
import { useLocale } from '../../../hooks/useLocale';
import { ShortUserModel } from './short_user.model';
import { ShortUser } from './transfer_unit';

interface FeeGroup {
  id: number;
  name: string;
  trade_fee: number;
  transaction_fee: number;
  created_by: ShortUser;
  is_default: boolean;
}

interface IMurabahaInvestor {
  id: number;
  english_name: string;
  arabic_name: string;
  email: string;
  mobile_number: string;
  is_active: boolean;
  national_id: string;
  user_type: string[];
  created_at: Date;
  fee_group: FeeGroup;
  vat: number | null;
  is_email_verified: boolean;
  preferred_language: string;
  iban: string;
}

class InvestorModel implements IMurabahaInvestor {
  id: number;
  english_name: string;
  arabic_name: string;
  email: string;
  mobile_number: string;
  is_active: boolean;
  national_id: string;
  user_type: string[];
  created_at: Date;
  fee_group: FeeGroup;
  vat: number;
  is_email_verified: boolean;
  preferred_language: string;
  iban: string;

  constructor(data: Partial<IMurabahaInvestor>) {
    this.id = data.id || 0;
    this.english_name = data.english_name || '';
    this.arabic_name = data.arabic_name || '';
    this.email = data.email || '';
    this.mobile_number = data.mobile_number || '';
    this.is_active = data.is_active || false;
    this.national_id = data.national_id || '';
    this.user_type = data.user_type || [];
    this.created_at = new Date(data.created_at) || new Date();
    this.fee_group = data.fee_group || {
      id: 0,
      name: '',
      trade_fee: 0,
      transaction_fee: 0,
      created_by: {
        id: 0,
        english_name: '',
        arabic_name: '',
      },
      is_default: false,
    };
    this.vat = data.vat || 0;
    this.is_email_verified = data.is_email_verified || false;
    this.preferred_language = data.preferred_language || 'en';
    this.iban = data.iban || '';
  }

  static fromJson(json: any): InvestorModel {
    return new InvestorModel(json);
  }

  toJson(): any {
    return {
      id: this.id,
      english_name: this.english_name,
      arabic_name: this.arabic_name,
      email: this.email,
      mobile_number: this.mobile_number,
      is_active: this.is_active,
      national_id: this.national_id,
      user_type: this.user_type,
      created_at: this.created_at.toISOString(),
      fee_group: this.fee_group,
      vat: this.vat,
      is_email_verified: this.is_email_verified,
      preferred_language: this.preferred_language,
      iban: this.iban,
    };
  }

  get fullName(): string {
    const { isArabic } = useLocale();
    return isArabic ? this.arabic_name : this.english_name;
  }

  get menuItemUser(): SelectMenuProps<number> {
    return {
      id: this.id.toString(),
      label: this.fullName,
      value: this.id,
    };
  }

  get shortUser(): ShortUserModel {
    return new ShortUserModel({
      id: this.id,
      english_name: this.english_name,
      arabic_name: this.arabic_name,
    });
  }
}

export default InvestorModel;
